import { get } from 'api';
import { APP_PRODUCT_TYPE, LOAD_MULTI_ACCOUNTS_PARAMS } from 'appConstants';
import { productTypeUrlPrefix } from 'utils';

import {
  LOAD_MULTI_ACCOUNTS,
  MULTI_ACCOUNTS_LOADED,
  RESET_ERROR,
  SYNC_FAILED,
} from './actionTypes';

export const initialActionsState = {
  loadMultiAccounts: () => {},
  resetError: () => {},
};

export const getActions = (dispatch: { (value: { type: any; payload?: any }): void }) => ({
  loadMultiAccounts: async (
    customerReference: string,
    productType: string = APP_PRODUCT_TYPE.FERTILISER,
  ) => {
    dispatch({
      type: LOAD_MULTI_ACCOUNTS,
    });

    const { data, error } = await get(
      productTypeUrlPrefix(productType, `/multi-accounts/${customerReference}`),
      {
        params: {
          limit: LOAD_MULTI_ACCOUNTS_PARAMS.LIMIT,
          offset: LOAD_MULTI_ACCOUNTS_PARAMS.OFFSET,
        },
      },
    );

    if (!error) {
      dispatch({
        type: MULTI_ACCOUNTS_LOADED,
        payload: {
          multiAccounts: Array.isArray(data) ? data : [],
          customerReference,
          productType,
        },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: {
          error,
          customerReference,
          productType,
        },
      });
    }
  },
  resetError: () =>
    dispatch({
      type: RESET_ERROR,
    }),
});
